// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__AoghY","position":"style_position__Nyupg"};